import { useEffect, useState } from "react";
import { api } from "@/api/client";
import { WhatsappLogo, CheckCircle } from "@phosphor-icons/react";
import { toast } from "sonner";

const COLUMNS = [
  { key: "overdue", label: "Overdue", bg: "#FF6B6B", emoji: "🚨" },
  { key: "due_today", label: "Due Today", bg: "#FFD166", emoji: "⏰" },
  { key: "this_week", label: "This Week", bg: "#4ECDC4", emoji: "📅" },
  { key: "upcoming", label: "Upcoming", bg: "#FFFFFF", emoji: "🗓️" },
];

export default function Reminders() {
  const [data, setData] = useState({ overdue: [], due_today: [], this_week: [], upcoming: [] });
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/reminders");
    setData(data);
    setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const send = async (cust, channel) => {
    try {
      const { data } = await api.post("/reminders/send", { customer_id: cust.customer_id, channel, mode: "template" });
      if (data?.ok) {
        toast.success(data.mocked
          ? `WhatsApp queued to ${cust.name} (MOCKED)`
          : `WhatsApp sent to ${cust.name}`);
      } else {
        toast.error(`WhatsApp send failed (${data?.meta_code || "unknown"})`, {
          description: data?.hint || data?.meta_message || "Meta rejected the send. Check API Setup.",
          duration: 15000,
        });
      }
    } catch {
      toast.error("Failed to send");
    }
  };
  const markServiced = async (id) => {
    await api.post("/customers/mark-serviced", { customer_id: id });
    toast.success("Marked serviced — schedule updated");
    load();
  };

  return (
    <div className="space-y-6">
      <div>
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#4A4A4A]">Action board</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mt-1">Reminders</h1>
      </div>

      {loading ? (
        <p className="font-semibold">Loading…</p>
      ) : (
        <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-5">
          {COLUMNS.map((col) => {
            const items = data[col.key] || [];
            return (
              <div key={col.key} className="nb-card overflow-hidden" data-testid={`col-${col.key}`}>
                <div className="px-4 py-3 border-b-2 border-black flex items-center justify-between" style={{ background: col.bg }}>
                  <div className="flex items-center gap-2">
                    <span className="text-xl">{col.emoji}</span>
                    <h3 className="font-heading font-black text-lg">{col.label}</h3>
                  </div>
                  <span className="text-xs font-black bg-white border-2 border-black rounded-full px-2 py-0.5 min-w-7 text-center">
                    {items.length}
                  </span>
                </div>
                <div className="p-3 space-y-3 max-h-[520px] overflow-y-auto">
                  {items.length === 0 ? (
                    <p className="text-sm text-[#4A4A4A] font-semibold py-6 text-center">Nothing here.</p>
                  ) : items.map((c) => (
                    <div key={c.customer_id} className="border-2 border-black rounded-md p-3 bg-white">
                      <p className="font-bold">{c.name}</p>
                      <p className="text-xs text-[#4A4A4A] font-semibold mb-2">
                        {c.business_type} • Next: {c.next_service_date}
                        {c.days_until < 0 ? ` • ${Math.abs(c.days_until)}d late` : c.days_until === 0 ? " • Today" : ` • in ${c.days_until}d`}
                      </p>
                      {c.next_service_km != null && (
                        <p className="text-xs font-mono font-bold text-[#4361EE] mb-2">
                          @ {c.next_service_km.toLocaleString()} km
                        </p>
                      )}
                      <p className="font-mono text-xs mb-3">{c.phone}</p>
                      <div className="flex gap-1.5 flex-wrap">
                        <button data-testid={`send-wa-${c.customer_id}`} onClick={() => send(c, "whatsapp")} className="nb-btn bg-[#06D6A0] text-black px-2.5 py-1.5 text-xs flex items-center gap-1">
                          <WhatsappLogo size={13} weight="bold" /> WhatsApp
                        </button>
                        <button data-testid={`mark-${c.customer_id}`} onClick={() => markServiced(c.customer_id)} className="nb-btn bg-[#FFD166] px-2.5 py-1.5 text-xs flex items-center gap-1">
                          <CheckCircle size={13} weight="bold" /> Done
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
